import type { Assignee, AnyObject } from '../types/sidebar.types';

export function extractAssignee(item: unknown): Assignee | null {
  if (item === undefined || item === null) {return null;}
  if (typeof item === 'string') {
    const s = item.trim();
    if (!s) {return null;}
    if (s.includes(',')) {
      const parts = s.split(',').map(p => p.trim()).filter(Boolean);
      if (parts.length >= 2) {
        const last = parts[0];
        const first = parts[1];
        return { firstName: first, lastName: last, display: `${first} ${last}` };
      }
    }
    const tokens = s.split(/\s+/).filter(Boolean);
    if (tokens.length >= 2) {return { firstName: tokens[0], lastName: tokens[tokens.length - 1], display: s }; }
    return { display: s };
  }
  if (typeof item === 'number') {return { display: String(item) };}
  if (Array.isArray(item)) {
    const out: Assignee[] = [];
    for (const it of item) {
      const a = extractAssignee(it);
      if (a) {out.push(a);}
    }
    return out.length > 0 ? out[0] : null;
  }
  if (typeof item === 'object') {
    const obj = item as Record<string, unknown>;

    const getFirstAvailable = (keys: string[]): string | null => {
      for (const k of keys) {
        const v = obj[k];
        if (typeof v === 'string') {
          const t = v.trim();
          if (t.length > 0) {return t;}
        }
        if (typeof v === 'number') {
          return String(v);
        }
      }
      return null;
    };

    const firstName = getFirstAvailable(['firstName', 'userFirstName', 'first_name']);
    const lastName = getFirstAvailable(['lastName', 'userLastName', 'last_name']);
    if (firstName || lastName) {
      return { firstName: firstName || null, lastName: lastName || null, display: `${firstName || ''} ${lastName || ''}`.trim() || null };
    }

    const cand = getFirstAvailable(['label', 'displayName', 'name', 'fullName', 'userName', 'username', 'email']);
    if (cand) { return extractAssignee(cand); }

    try {
      for (const k of Object.keys(obj)) {
        const v = obj[k];
        if (typeof v === 'string' && v.trim().length > 0) { return extractAssignee(v.trim()); }
      }
    } catch (e) { /* ignore */ }

    return null;
  }
  return null;
}

export function getInitialsFromName(name?: string | null): string {
  if (!name) {return '';}
  let s = String(name).trim();
  if (s.includes(',')) {
    const parts = s.split(',').map(p => p.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const lastSeg = parts[parts.length - 1];
      const firstSeg = parts.slice(0, parts.length - 1).join(' ');
      if (lastSeg.includes(' ')) {
        s = lastSeg;
      } else {
        s = `${lastSeg} ${firstSeg}`.trim();
      }
    }
  }
  const tokens = s.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) {return '';}
  if (tokens.length === 1) {return tokens[0].slice(0, 2).toUpperCase();}
  const firstInitial = String(tokens[0][0] || '').toUpperCase();
  const lastInitial = String(tokens[tokens.length - 1][0] || '').toUpperCase();
  return `${firstInitial}${lastInitial}`;
}
